import React from 'react';
import { Link } from 'react-router-dom';
import CheckoutForm from '../common/forms/checkout-form';

const AssinarAgoraArea = ({cdPlano}) => {
  return (
    <>
      <section className="po-rel-z1 pt-100 pb-145">
        
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="section__title-wrapper text-center mb-55">
                <h2 className="section__title">Assinar Agora</h2>
                <p>Pagamento online com segurança, este ambiente foi homologado pela Stone Pagarme <span>&#174;</span>.</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-12">
              <div className="sign__wrapper white-bg">
                <div className="sign__form">
                  {/* checkout form */}
                  <CheckoutForm cdPlano={cdPlano} />
                  {/* checkout form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AssinarAgoraArea;